(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  // Reveal the sticky header's collapsed nav on hover (desktop).
  // On scroll-down StoreHeader adds `is-out`, collapsing the nav-links row.
  // Moving the pointer onto the header re-opens it; leaving re-collapses it
  // while still scrolled down. Reuses StoreHeader's own show()/hide() so the
  // transition and scroll bookkeeping stay in sync. The mega-menu panels are
  // descendants of store-header, so hovering into a dropdown never fires
  // mouseleave and never collapses the menu mid-interaction.
  customElements.whenDefined('store-header').then(() => {
    const header = document.querySelector('store-header[data-is-sticky="true"]');
    if (!header) return;

    const isDesktop = () => window.matchMedia(theme.mediaQueries.md).matches;

    header.addEventListener('mouseenter', () => {
      if (isDesktop() && header.classList.contains('is-out')) header.show();
    });

    header.addEventListener('mouseleave', () => {
      if (
        isDesktop() &&
        document.documentElement.scrollTop >= 200 &&
        !document.body.classList.contains('fixed')
      ) {
        header.hide();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
